/*

class to generate alias

{
  "id" : Ex userId, channelId, workspaceId
  "type" : optional type for lookup
  "alias" : display name
}

*/

// Import variables
const Joi = require('joi');

// Import variables
const { joiValidateObj } = require('../datastructComponents');

// Create schema
const schema = {
  id: Joi.string().required(),
  type: Joi.string().optional(),
  alias: Joi.string().required(),
};


// Define class
class Alias {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Alias = Alias;
exports.aliasSchema = schema;